module.exports = __webpack_public_path__ + "img/logoSlide1.d3c2f43f.png";